"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prize = void 0;
const PrizeType_1 = require("../../enums/game/PrizeType");
const GameWinnerType_1 = require("../../enums/player/GameWinnerType");
exports.prize = {
    isEnable: false,
    numberOfWinners: 0,
    winnerType: GameWinnerType_1.GameWinnerType.RANDOMIZE,
    minimumHighScore: 0,
    type: PrizeType_1.PrizeType.COUPON_CODE_GENERAL,
    value: '',
    email: '',
    numberOfCoupon: 0,
    isSendThroughEmail: false,
};
